
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.214 2A2.214 2.214 0 002 4.214v15.572C2 21.01 2.991 22 4.214 22h15.572A2.214 2.214 0 0022 19.786V4.214A2.214 2.214 0 0019.786 2H4.214zm5.57 3.896l6.322 3.816a.889.889 0 010 1.514L9.785 15.04c-.57.345-1.3-.07-1.3-.757v-7.63c0-.766.786-1.066 1.3-.757zm9.95 12.162a.6.6 0 01.6.6v1.023a.6.6 0 01-.6.6H17.6a.6.6 0 01-.6-.6v-1.023a.6.6 0 01.6-.6h2.133zm-3.845.6a.6.6 0 00-.6-.6h-2.133a.6.6 0 00-.6.6v1.023a.6.6 0 00.6.6h2.133a.6.6 0 00.6-.6v-1.023zm-5.045-.6a.6.6 0 01.6.6v1.023a.6.6 0 01-.6.6H8.711a.6.6 0 01-.6-.6v-1.023a.6.6 0 01.6-.6h2.133zm-3.844.6a.6.6 0 00-.6-.6H4.267a.6.6 0 00-.6.6v1.023a.6.6 0 00.6.6H6.4a.6.6 0 00.6-.6v-1.023z","fill":"#191F2D"}})])
          )
        }
      }
    